<template>
  <!-- NOTE: this is not user resizeable -->
  <LabelOutlined
    :label="label"
    :is_disabled="is_disabled"
    :is_ready="!is_disabled"  
    :width="width + 'px' || '100%'"
    :height="(resize ? '0' : height) || 128"
    :dark="is_light_mode(getColor(foreground_color))"
    :background_color="getColor(background_color)"
  >
    <template #content>
      <!-- CENTER -->
      <div :style="(height && !resize) ?`height: ${height}px`:''" class="text-area-component-container">
        <textarea
          class="text-area-component"
          :id="autofocus_id"
          :value="local_value"
          :label="label"
          :placeholder="placeholder"
          :style="`
            color: ${getColor(foreground_color)};
            font-size: ${font_size}pt;
            font-weight: ${font_weight};
            ${resize
              ? 'resize: vertical; min-height: 30px; max-height: 200px;'
              : ''}
            cursor: ${is_disabled ? 'default' : 'auto'};
          `"
          :maxlength="max_char_count"
          :readonly="is_disabled"
          @change="$emit('change', local_value)"
          @input="local_value = $event.target.value"
        />
        <!-- @change="$emit('change', $event.target.value)" -->


        <!-- OPTIONAL CHAR COUNTER -->
        <div
          v-if="max_char_count"
          class="text-area-component-counter"
        >
          <TText
            :text="`${local_value.length}/${max_char_count}`"
            :size="12"
            :color="getColor(foreground_color)"
          />
        </div>
      </div>
    </template>
  </LabelOutlined>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue';
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      TText,
      LabelOutlined,
    },

    mixins: [
      WorkPackageWIPMixin,
      TColor,
    ],

    props: [
      'value', // is string, is value of textarea
      'label', // is string, is label and descriptor of textarea shown in top border
      'autofocus_id', // is string, unique id to force focus on mounted
      'placeholder', // is string, is placeholder of textarea
      'max_char_count', // is number, limits amout of chars
      'is_disabled', // is boolean, controls focus-within behaviour and readonly of textarea
      'width', // is number, width of textarea component
      'height', // is number, height of textarea component
      'font_size',  // is number, controls size of font in pt
      'font_weight', // is number, ccontrols font-weight (200, 300, 400, etc.)
      'background_color',
      'foreground_color',
    ],

    data: () => ({
      // text_input: '',
      local_value: '',
    }),

    computed: {
      resize() {
        let a = this.$attrs;
        if(a.resize !== undefined) {
          if(a.resize || a.resize === '')
            { return true; } }
        return false;
      },
    },

    created() {

    },
    mounted() {
      // if(this.text) {
      //   this.text_input = this.text;
      // }
      if(this.autofocus_id) {
        document.getElementById(this.autofocus_id).focus();
      }
      if (this.value) {
        this.local_value = this.value;
      }
    },
    watch: {
      value() {
        this.local_value = this.value;

      }
    }
  }
</script>

<style>
.text-area-component-container {
  display: flex;
  flex-direction: column;
  border-color: inherit;
  width: 100%;
  height: 100%;
  flex-grow: 1;
}
.text-area-component {
  flex-grow: 1;
  resize: none;
  /* height: 2000px; */
}
.text-area-component-counter {
  min-height: 24px;
  margin: 8px;
  margin-bottom: 0;
  display: flex;
  justify-content: flex-end;
}
.text-area-component:focus {
  outline: none;
}
</style>
